import React, { useState, useEffect } from 'react';

function SenderProfileDialog({ onClose, onSave, initialData }) {
    const [profile, setProfile] = useState(initialData || {
        name: '',
        businessName: '',
        companySummary: '',
        address: '',
        phone: '',
        email: '',
        website: '',
        taxNo: '',
        chamberNo: '',
        language: 'English',
        currency: 'USD',
        avatar: null
    });

    useEffect(() => {
        if (initialData) {
            setProfile({
                ...initialData,
                language: initialData.language || 'English',
                currency: initialData.currency || 'USD',
            });
        }
    }, [initialData]);

    const handleSave = () => {
        if (!profile.name.trim() || !profile.businessName.trim()) {
            alert('Please enter both Name and Business Name.');
            return;
        }
        onSave(profile);
    };
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (ev) => {
                const img = new window.Image();
                img.onload = () => {
                    const maxDim = 640;
                    let { width, height } = img;
                    let newWidth = width;
                    let newHeight = height;
                    if (width > maxDim || height > maxDim) {
                        if (width > height) {
                            newWidth = maxDim;
                            newHeight = Math.round((height / width) * maxDim);
                        } else {
                            newHeight = maxDim;
                            newWidth = Math.round((width / height) * maxDim);
                        }
                    }
                    const canvas = document.createElement('canvas');
                    canvas.width = newWidth;
                    canvas.height = newHeight;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, newWidth, newHeight);
                    const resizedDataUrl = canvas.toDataURL('image/png');
                    setProfile(prev => ({ ...prev, avatar: resizedDataUrl }));
                };
                img.src = ev.target.result;
            };
            reader.readAsDataURL(file);
        }
    };

    return (
        <div className="dialog-overlay" onClick={onClose}>
            <div className="dialog-content wide-dialog" onClick={e => e.stopPropagation()}>
                <div className="dialog-header">
                    <h3>Company Info</h3>
                    <button className="close-button" onClick={onClose}>×</button>
                </div>
                <div className="dialog-body">
                    <div className="profile-avatar-row" style={{display: 'flex', alignItems: 'center', gap: 24, marginBottom: 32}}>
                        <div className="profile-avatar-section">
                            <label htmlFor="profile-avatar-upload" className="profile-avatar-placeholder" style={{cursor: 'pointer'}}>
                                {profile.avatar ? (
                                    <img src={profile.avatar} alt="Avatar" style={{width: 48, height: 48, borderRadius: '50%', objectFit: 'cover'}} />
                                ) : (
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" stroke="#bbb">
                                        <circle cx="24" cy="18" r="10" strokeWidth="2" />
                                        <path d="M8 44c0-6 8-10 16-10s16 4 16 10" strokeWidth="2" />
                                    </svg>
                                )}
                                <input
                                    id="profile-avatar-upload"
                                    type="file"
                                    accept="image/*"
                                    style={{display: 'none'}}
                                    onChange={handleImageChange}
                                />
                            </label>
                        </div>
                        <div className="form-group" style={{flex: 1, marginBottom: 0}}>
                            <label>Name <span style={{color: 'red'}}>*</span></label>
                            <input
                                type="text"
                                placeholder="John Thomas"
                                value={profile.name}
                                onChange={e => setProfile({ ...profile, name: e.target.value })}
                                required
                            />
                        </div>
                    </div>
                    <div className="section-label">BUSINESS DETAILS</div>
                    <div className="form-row">
                        <div className="form-group">
                            <label>Business name <span style={{color: 'red'}}>*</span></label>
                            <input
                                type="text"
                                placeholder="Pine Tech"
                                value={profile.businessName}
                                onChange={e => setProfile({ ...profile, businessName: e.target.value })}
                                autoFocus
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Company summary</label>
                            <input
                                type="text"
                                placeholder="Company summary"
                                value={profile.companySummary}
                                onChange={e => setProfile({ ...profile, companySummary: e.target.value })}
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group">
                            <label>Address</label>
                            <input
                                type="text"
                                placeholder="Address"
                                value={profile.address}
                                onChange={e => setProfile({ ...profile, address: e.target.value })}
                            />
                        </div>
                        <div className="form-group">
                            <label>Phone</label>
                            <input
                                type="tel"
                                placeholder="Phone"
                                value={profile.phone}
                                onChange={e => setProfile({ ...profile, phone: e.target.value })}
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                placeholder="Email"
                                value={profile.email}
                                onChange={e => setProfile({ ...profile, email: e.target.value })}
                            />
                        </div>
                        <div className="form-group">
                            <label>Website</label>
                            <input
                                type="url"
                                placeholder="Website"
                                value={profile.website}
                                onChange={e => setProfile({ ...profile, website: e.target.value })}
                            />
                        </div>
                    </div>
                    <div className="section-label">TAX INFORMATION</div>
                    <div className="form-row">
                        <div className="form-group">
                            <label>Tax no.</label>
                            <input
                                type="text"
                                placeholder="Tax no."
                                value={profile.taxNo}
                                onChange={e => setProfile({ ...profile, taxNo: e.target.value })}
                            />
                        </div>
                        <div className="form-group">
                            <label>Chamber no.</label>
                            <input
                                type="text"
                                placeholder="Chamber no."
                                value={profile.chamberNo}
                                onChange={e => setProfile({ ...profile, chamberNo: e.target.value })}
                            />
                        </div>
                    </div>
                    <div className="section-label">LANGUAGE & CURRENCY</div>
                    <div style={{ display: 'flex', gap: 24, alignItems: 'flex-end', marginBottom: 24 }}>
                        <div className="form-group" style={{ flex: 1 }}>
                            <label>Language</label>
                            <select
                                className="large-select"
                                value={profile.language}
                                onChange={e => setProfile({ ...profile, language: e.target.value })}
                            >
                                <option value="English">English</option>
                                <option value="Dutch">Dutch</option>
                                <option value="French">French</option>
                                <option value="German">German</option>
                                <option value="Italian">Italian</option>
                                <option value="Spanish">Spanish</option>
                            </select>
                        </div>
                        <div className="form-group" style={{ flex: 1 }}>
                            <label>Currency</label>
                            <select
                                className="large-select"
                                value={profile.currency}
                                onChange={e => setProfile({ ...profile, currency: e.target.value })}
                            >
                                <option value="USD">US Dollar (USD)</option>
                                <option value="EUR">Euro (EUR)</option>
                                <option value="GBP">British Pound (GBP)</option>
                                <option value="CHF">Swiss Franc (CHF)</option>
                                <option value="CAD">Canadian Dollar (CAD)</option>
                                <option value="AUD">Australian Dollar (AUD)</option>
                                <option value="NZD">New Zealand Dollar (NZD)</option>
                                <option value="JPY">Japanese Yen (JPY)</option>
                                <option value="CNY">Chinese Yuan (CNY)</option>
                                <option value="INR">Indian Rupee (INR)</option>
                                <option value="BRL">Brazilian Real (BRL)</option>
                                <option value="ZAR">South African Rand (ZAR)</option>
                                <option value="SEK">Swedish Krona (SEK)</option>
                                <option value="NOK">Norwegian Krone (NOK)</option>
                                <option value="DKK">Danish Krone (DKK)</option>
                                <option value="SGD">Singapore Dollar (SGD)</option>
                                <option value="HKD">Hong Kong Dollar (HKD)</option>
                                <option value="MXN">Mexican Peso (MXN)</option>
                                <option value="TRY">Turkish Lira (TRY)</option>
                                <option value="RUB">Russian Ruble (RUB)</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="dialog-footer">
                    <button className="btn-cancel" onClick={onClose}>Cancel</button>
                    <button className="btn-save" onClick={handleSave} disabled={!profile.name.trim() || !profile.businessName.trim()}>Save</button>
                </div>
            </div>
        </div>
    );
}

export default SenderProfileDialog;
